import { writable } from "svelte/store";

export type PaymentsStore = {
  loaded: boolean;
  failed: boolean;
  errors?: PaymentsError[];
};

export type PaymentsError = {
  invoice_id: number;
  invoice_reference_id: string;
  error: string[];
};

const initialPaymentsStore: PaymentsStore = { loaded: true, failed: false };

export const PaymentsStore = writable<PaymentsStore>(initialPaymentsStore);
